import * as toast from '/source/js/utils/toastUtil';

export function clearCouponFieldOnSuccess($closeIcon) {
    let couponInput = $($closeIcon).siblings('.cart-coupon__input');
    $(couponInput).find('.form-label').removeClass('is--active');
    const couponId = $(couponInput).data('coupon-id');
    $(couponInput).find(`input[type="text"][name="${couponId}"]`).val('');
    const text = $closeIcon.data('coupon-applied-text');
    if($closeIcon.length && text) {
        toast.Success(text);
    }
}

export const ADD_TO_CART_LOADING_STARTED_MESSAGE = 'adding item to cart started';
export const ADD_TO_CART_LOADING_COMPLETED_MESSAGE = 'adding item to cart completed successfully';
export const ADD_TO_CART_LOADING_ERROR_MESSAGE = 'Error while adding item to cart';
export const CREATE_COPY_LINK_STARTED_MESSAGE = 'creating share link started';
export const CREATE_COPY_LINK_COMPLETED_MESSAGE = 'creating share link completed successfully';
export const CREATE_COPY_LINK_ERROR_MESSAGE = 'Error while creating share link';
export const UPDATE_TO_CART_LOADING_STARTED_MESSAGE = 'updating item in cart started';
export const UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE = 'updating item in cart completed successfully';
export const UPDATE_TO_CART_LOADING_ERROR_MESSAGE = 'Error while updating item in cart';
